/**
 * Get the value for field
 * @param {object} row - the row object
 * @param {object} field - the field object
 */
export const getRowValueForField = (row, field) => {
  if (!field) return null
  const key = `field_${field.id}`
  return row?.attributes?.values?.[key]
}
